import React from 'react';
import { Link } from 'react-router-dom';
import { Ear } from '@phosphor-icons/react';

/**
 * Page publique — Mentions légales (LCEN art. 6-III et 19).
 * Accessible via /mentions-legales et lien de bas de page.
 */
export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen bg-zinc-50" data-testid="mentions-legales-page">
      <header className="bg-zinc-900 text-white">
        <div className="max-w-4xl mx-auto px-4 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <Ear size={28} weight="bold" />
            <span className="font-heading font-bold text-lg tracking-wider">HAMAC SOLUTIONS</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-10">
        <div className="bg-white border border-zinc-200 rounded-sm p-6 sm:p-10">
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-zinc-900 mb-8 pb-4 border-b-2 border-zinc-900">
            MENTIONS L&Eacute;GALES
          </h1>

          <p className="text-sm sm:text-base text-zinc-700 leading-relaxed mb-8">
            Conform&eacute;ment aux dispositions des articles 6-III et 19 de la loi n&deg; 2004-575 du 21 juin 2004 pour la confiance dans l'&eacute;conomie num&eacute;rique (dite &laquo;&nbsp;LCEN&nbsp;&raquo;), il est port&eacute; &agrave; la connaissance des utilisateurs et visiteurs du site <strong>hamacsolutions</strong> les pr&eacute;sentes mentions l&eacute;gales.
          </p>

          <div className="space-y-8 text-sm sm:text-base text-zinc-700 leading-relaxed">
            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">1. &Eacute;diteur du site</h2>
              <p>
                Le site hamacsolutions.com est &eacute;dit&eacute; par la soci&eacute;t&eacute; <strong>HAMAC</strong>, soci&eacute;t&eacute; &agrave; responsabilit&eacute; limit&eacute;e (SARL) unipersonnelle au capital social de 10 000 &euro;, exer&ccedil;ant sous le nom commercial <strong>HAMAC SOLUTIONS</strong>.
              </p>
              <ul className="list-none space-y-1 mt-3">
                <li><strong>Si&egrave;ge social&nbsp;:</strong> Rue des Vignes, 01090 Gu&eacute;reins, France</li>
                <li><strong>SIREN&nbsp;:</strong> 928 122 761</li>
                <li><strong>SIRET (si&egrave;ge social)&nbsp;:</strong> 928 122 761 00028</li>
                <li><strong>RCS&nbsp;:</strong> Bourg-en-Bresse</li>
                <li><strong>N&deg; TVA intracommunautaire&nbsp;:</strong> FR76928122761</li>
                <li><strong>T&eacute;l&eacute;phone&nbsp;:</strong> <a href="tel:+33465847655" className="text-zinc-900 underline font-medium">04 65 84 76 55</a></li>
                <li><strong>E-mail&nbsp;:</strong> <a href="mailto:jordan.claude@pm.me" className="text-zinc-900 underline font-medium">jordan.claude@pm.me</a></li>
                <li><strong>Directeur de la publication&nbsp;:</strong> Jordan CLAUDE, en qualit&eacute; de g&eacute;rant</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">2. H&eacute;bergement</h2>
              <p>Le site hamacsolutions est h&eacute;berg&eacute; par la soci&eacute;t&eacute; <strong>IONOS SARL</strong>.</p>
              <ul className="list-none space-y-1 mt-3">
                <li><strong>Adresse&nbsp;:</strong> 7, place de la Gare, BP 70109, 57200 Sarreguemines Cedex, France</li>
                <li><strong>T&eacute;l&eacute;phone&nbsp;:</strong> 09 70 80 89 11</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">3. Propri&eacute;t&eacute; intellectuelle</h2>
              <p>
                L'ensemble des contenus pr&eacute;sents sur le site hamacsolutions (textes, images, graphismes, logos, ic&ocirc;nes, etc.) est la propri&eacute;t&eacute; exclusive de la soci&eacute;t&eacute; HAMAC, sauf mention contraire, et est prot&eacute;g&eacute; par les dispositions du Code de la propri&eacute;t&eacute; intellectuelle. Toute reproduction, repr&eacute;sentation, modification, publication ou adaptation de tout ou partie des &eacute;l&eacute;ments du site, quel que soit le moyen ou le proc&eacute;d&eacute; utilis&eacute;, est interdite sans l'autorisation &eacute;crite pr&eacute;alable de la soci&eacute;t&eacute; HAMAC.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">4. Donn&eacute;es personnelles et cookies</h2>
              <p>
                Le traitement des donn&eacute;es personnelles collect&eacute;es sur le site hamacsolutions ainsi que l'utilisation de cookies sont d&eacute;taill&eacute;s dans notre <Link to="/confidentialite" className="text-zinc-900 underline font-medium" data-testid="link-privacy">Politique de confidentialit&eacute;</Link>, &agrave; laquelle nous vous invitons &agrave; vous r&eacute;f&eacute;rer.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">5. Limitation de responsabilit&eacute;</h2>
              <p>
                La soci&eacute;t&eacute; HAMAC s'efforce d'assurer l'exactitude et la mise &agrave; jour des informations diffus&eacute;es sur le site hamacsolutions, mais ne peut garantir l'exhaustivit&eacute; des informations mises &agrave; disposition. La soci&eacute;t&eacute; HAMAC d&eacute;cline toute responsabilit&eacute; pour toute interruption du site, survenance de bogues, ou pour tout dommage r&eacute;sultant d'un acte frauduleux d'un tiers ayant entra&icirc;n&eacute; une modification des informations mises &agrave; disposition sur le site.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-semibold text-lg text-zinc-900 mb-3">6. Droit applicable et juridiction comp&eacute;tente</h2>
              <p>
                Les pr&eacute;sentes mentions l&eacute;gales sont soumises au droit fran&ccedil;ais. En cas de litige, et &agrave; d&eacute;faut de r&eacute;solution amiable, les tribunaux fran&ccedil;ais seront seuls comp&eacute;tents.
              </p>
            </section>
          </div>

          <div className="mt-10 pt-6 border-t border-zinc-200 text-sm">
            <Link to="/" className="text-zinc-900 underline font-medium" data-testid="link-home">&larr; Retour &agrave; l'accueil</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
